import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/settings/users/')({
  beforeLoad: () => {
    throw redirect({ to: '/users' })
  },
})
